{
  "name": "vortex",
  "doc": "Zoom and a rotation that grows with the radius: the edge turns faster than the centre, so a straight line becomes an arm of a whirlpool in a few frames.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.018,
  "zoomexp": 1.0,
  "rot": 0.01,
  "rotr": 0.045,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.962,
  "invert": 0,
  "hueShift": 0.004,
  "darkenCenter": 0.35,
  "wave": "LINE",
  "waveColor": 0,
  "shapes": 0,
  "energy": [
    0.55,
    1.0
  ]
}